import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchEnergyOverTime } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import { constants } from '../../../shared/constants';
import { chartObjectCreator } from '../../../utils/helper';
import CustomHighChart from './CustomHighChart';

const colors = _.shuffle(constants.colorObj);
const ChartEfficiencyOverTime = ({ type, id, units }) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const drawChart = async (_data) => {
    const Loss = [];
    const Efficiency = [];
    const Hours = [];

    _.map(_data, (item) => {
      Loss.push([item.hours, item.loss]);
      Efficiency.push([item.hours, item.efficiency]);

      // eslint-disable-next-line radix
      Hours.push([parseInt(item.hours)]);
    });
    const chart = await chartObjectCreator({
      chart: {
        renderTo: 'chrtContainer',
        height: '500px',
      },
      xAxis: {
        type: 'category',
        categories: Hours,
        title: {
          text: 'Hours',
        },
      },
      yAxis: [
        {
          height: '50%',
          title: {
            text: 'Efficiency %',
          },
        },
        {
          opposite: true,
          height: '50%',
          title: {
            text: '',
          },
          resize: {
            enabled: true,
            controlledAxis: {
              next: ['atr'],
              prev: [0],
            },
          },
        },
        {
          top: '55%',
          height: '50%',
          offset: 0,
          title: {
            text: `Losses ${units?.powerUnit || ''}`,
          },
          id: 'atr',
        },
      ],
      series: [
        {
          name: 'Efficiency %',
          color: colors[0],
          data: Efficiency,
          legendIndex: 1,
        },
        {
          name: `Loss ${units?.powerUnit || ''}`,
          color: colors[1],
          yAxis: 2,
          legendIndex: 1,
          visible: true,
          data: Loss,
        },
      ],
    });
    setData(chart);
  };

  const bindData = async () => {
    setLoading(true);
    setData({});
    fetchEnergyOverTime(type, id)
      .then((response) => {
        setLoading(false);
        const { statusCode, result } = response.data;
        drawChart(statusCode === 200 ? result : []);
      })
      .catch((error) => {
        setLoading(false);
        drawChart([]);
        console.log(error);
      });
  };

  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        bindData();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, id]);

  return <CustomHighChart isLoading={isLoading} options={data} />;
};

export default ChartEfficiencyOverTime;
